export function normalizeMarkdown(text: string): string {
  return text
    .replace(/\n{3,}/g, '\n\n')
    .replace(/\n\n(\s*[-*•]\s)/g, '\n$1')
    .replace(/\n\n(\s*\d+\.\s)/g, '\n$1')
    .replace(/(\n|^)(\s*)[•](\s)/g, '$1$2- $3');
}
